import {useCallback, useEffect, useRef, useState} from "react";
import {EmpLearningRestControllerApiFactory, WikiPage} from "arteco-api-client-ts";
import {useApiManager} from "../utils/api";

interface WikiPageState {
	page?: WikiPage;
	loading: boolean;
	notFound: boolean;
}

/** Carga una página publicada de la wiki por sección y código. Una sola petición por código. */
export const useWikiPage = (code?: string, section?: string) => {
	const apiManager = useApiManager();
	const apiRef = useRef(apiManager);
	apiRef.current = apiManager;
	const [state, setState] = useState<WikiPageState>({loading: !!code, notFound: false});
	const requestRef = useRef(0);

	const load = useCallback(() => {
		if (!code || !section) {
			setState({loading: false, notFound: false});
			return;
		}
		const request = ++requestRef.current;
		setState(s => ({...s, loading: true, notFound: false}));
		const ctrl = apiRef.current.factory(EmpLearningRestControllerApiFactory);
		apiRef.current.execute(ctrl.getPageLearning(code, section)).then(
			page => request === requestRef.current && setState({page, loading: false, notFound: false}),
			() => request === requestRef.current && setState({loading: false, notFound: true}),
		);
	}, [code, section]);

	useEffect(() => {
		load();
		return () => { requestRef.current++; };
	}, [load]);

	return {...state, reload: load};
};
